export function toAbsoluteUrl(url: string): string {
  if (url.startsWith('http')) return url
  if (url.startsWith('//')) return `https:${url}`
  return `https://${url}`
}
